// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-55f5822a]{max-width:-moz-max-content;max-width:max-content;width:100%;border-radius:4px}.required-star[data-v-55f5822a]{color:red;font-weight:700}table[data-v-55f5822a]{text-align:center}table td[data-v-55f5822a],table th[data-v-55f5822a]{padding:8px}table input[type=checkbox][data-v-55f5822a],table input[type=radio][data-v-55f5822a]{width:16px;height:16px}", ""]);
// Exports
module.exports = exports;
